import { createAction } from 'redux-actions';
import { Layout } from '../../types/layout';

export const fetchLayoutSuccess = createAction<Layout>('LAYOUT.FETCH.SUCCESS');

export type MoveModuleActionPayload = {
  section: string;
  zone: string;
  moduleId: number;
  position: number;
};

export type RemoveModuleActionPayload = {
  section: string;
  zone: string;
  moduleId: number;
};

export type UpdateModuleOrderActionPayload = {
  section: string;
  zone: string;
  order: number[];
  version?: number;
};

export type AddModuleActionPayload = {
  section: string;
  zone: string;
  moduleType: string;
  position: number;
};

export type SectionLayoutVersionPayload = {
  section: string;
  version: number;
};

export const moveModule = createAction<MoveModuleActionPayload>(
  'LAYOUT.MOVE_MODULE'
);

export const updateModuleOrderSuccess = createAction<
  UpdateModuleOrderActionPayload
>('LAYOUT.UPDATE_MODULE_ORDER.SUCCESS');

export const removeModule = createAction<RemoveModuleActionPayload>(
  'LAYOUT.REMOVE_MODULE'
);
export const addModule = createAction<AddModuleActionPayload>(
  'LAYOUT.ADD_MODULE'
);
export const addModuleSuccess = createAction<AddModuleActionPayload>(
  'LAYOUT.ADD_MODULE_SUCCESS'
);

export const updateSectionLayoutVersion = createAction<
  SectionLayoutVersionPayload
>('LAYOUT.UPDATE_VERSION');
